
import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useMediaQuery,
  Pagination,
  CircularProgress 
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useTranslation } from "react-i18next";
import CustomText, { textStyles } from "../../../components/CustomText";
import ExportDropdown from "../../../components/ExportDropdown";
import tablefilter from "../../../assets/tablefilter.svg";
import StatusDropdown from "../../../components/StatusDropdown";
import SearchInput from "../../../components/SearchInput";
import { showUnderDevelopment } from "../../../components/alerts.js"
import { useSelector } from "react-redux";
import { decryptToken } from "../../../Utlis/Encryption.js";
import { BASE_URL } from "../../../components/BaseUrl.js";
import TruncatedCell from "../../../components/TruncatedCell.js";
import { ArrowDownward, ArrowUpward } from "@mui/icons-material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Menu, MenuItem } from "@mui/material";
import { useNavigate,useLocation } from "react-router-dom";
 import FilterAltIcon from "@mui/icons-material/FilterAlt";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import empty from "../../../assets/empty.png";
import mapicon from "../../../assets/Dashboard/mapicon.svg";
import {
  convertLocalDateTimeToUTC,
  convertUTCToLocalDateTime,
} from "../../../components/dateTimeUtils";

/** Local calendar date (YYYY-MM-DD) → UTC ISO for API from/to params */
const filterDateToUtcParam = (dateOnly, boundary = "start") => {
  if (!dateOnly) return null;
  const time = boundary === "start" ? "00:00:00" : "23:59:59";
  return convertLocalDateTimeToUTC(`${dateOnly}T${time}`);
};

// ✅ Status colors remain same
const statusColors = {
  Assigned: "#8F00FF",
  Ongoing: "#8E65E9",
  Completed: "#00C48C",
  Delayed: "#FF974A",
  Paused: "#FFDC60",
};

const TasksTable = ({ onSelectTask }) => {
const rawEncryptedToken = localStorage.getItem("token");
  const token = rawEncryptedToken ? decryptToken(rawEncryptedToken) : null;

  const isMobile = useMediaQuery("(max-width:768px)");
  const { t } = useTranslation();
  const [openAddTask, setOpenAddTask] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [tasks, setTasks] = useState([]);
  const [deleteTaskId, setDeleteTaskId] = useState(null);
  const [openFilterDrawer, setOpenFilterDrawer] = useState(false); // ✅ filter drawer
const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [filters, setFilters] = useState({
    status: "",
    startDate: "",
    endDate: "",
  });
const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [loading, setLoading] = useState(false);
const [page, setPage] = useState(1);
const [sortOrder, setSortOrder] = useState("desc");
const [openEditTask, setOpenEditTask] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
const [totalPages, setTotalPages] = useState(1);
const location = useLocation();
  const navigate = useNavigate();
  const fromDashboard = location.state?.fromDashboard;

  const pageSize = 5;

  const fetchTasks = async (page = 1, sort = sortOrder, filters = {}, search = "") => {
  try {
    setLoading(true);

    let url = `${BASE_URL}/task-management/worker/tasks?page=${page}&page_size=${pageSize}&sort=created_at:${sort}&sort_by=created_at&sort_order=${sort}`;
    const fromUtc = filterDateToUtcParam(filters.startDate, "start");
    const toUtc = filterDateToUtcParam(filters.endDate, "end");
    if (fromUtc) url += `&from=${encodeURIComponent(fromUtc)}`;
    if (toUtc) url += `&to=${encodeURIComponent(toUtc)}`;
    if (filters.status) url += `&status=${filters.status}`;
    if (search?.trim()) url += `&search=${encodeURIComponent(search.trim())}`;

    const res = await fetch(url, {
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    });
    const data = await res.json();

    if (!data.error) {
      const backendPages = Number(
        data?.data?.pagination?.pages ||
        data?.data?.pagination?.totalPages ||
        data?.data?.pagination?.total_pages ||
        1
      );

      setTasks(data?.data?.tasks || []);
      setTotalPages(Math.max(1, backendPages));
      setPage(page);
    } else {
      setTasks([]);
      setTotalPages(1);
    }
  } catch (err) {
    console.error("❌ Error fetching tasks:", err);
    setTasks([]);
    setTotalPages(1);
  } finally {
    setLoading(false);
    setIsInitialLoad(false);
  }
};


  useEffect(() => {
    fetchTasks(page, sortOrder, filters, searchTerm);
  }, [page, sortOrder, filters, searchTerm]);

useEffect(() => {
  setPage(1);
}, [searchTerm, sortOrder, filters]);
const toggleSort = () => {
  setSortOrder((prev) => {
    const newOrder = prev === "desc" ? "asc" : "desc";
    console.log("🔄 Sort order changed:", newOrder); // ✅ log sort order
    return newOrder;
  });
};
  const HaederStyles = {
    color: "#44546F",
    fontSize: "13px",
    fontFamily: "Poppins, sans-serif",
    fontWeight: 600,
    whiteSpace: 'nowrap', // ✅ Prevent text wrap
   
      overflow: 'hidden',
  textOverflow: 'ellipsis',
  };

  const DataStyles = {
    color: "#172B4D",
    fontSize: "13px",
    fontFamily: "Poppins, sans-serif",
    fontWeight: 400,
    whiteSpace: 'nowrap', // ✅ Prevent text wrap
   
      overflow: 'hidden',
  textOverflow: 'ellipsis',
  };
// 🔹 Helper function for date formatting (UTC from API → local display)
const formatDateTime = (dateString) => {
  if (!dateString) return "-";
  const localDateTime = convertUTCToLocalDateTime(dateString, { locale: "en-GB" });
  return localDateTime === "—" ? "-" : localDateTime;
};


const [anchorEl, setAnchorEl] = useState(null);
const [selectedRow, setSelectedRow] = useState(null);

const handleMenuOpen = (event, row) => {
  setAnchorEl(event.currentTarget);
  setSelectedRow(row);
};

const handleMenuClose = () => {
  setAnchorEl(null);
  setSelectedRow(null);
};

const handleView = async () => {
  if (selectedRow) {
    onSelectTask(selectedRow.id); // ✅ pass only the task id
  }
  handleMenuClose();
};

const fetchAllTasks = async (token, filters = {}, sortOrder = "desc") => {
  try {
    // use a high page_size to bypass pagination
    let url = `${BASE_URL}/task-management/worker/tasks?page=1&page_size=50000&sort=created_at:${sortOrder}&sort_by=created_at&sort_order=${sortOrder}`;

    const fromUtc = filterDateToUtcParam(filters.startDate, "start");
    const toUtc = filterDateToUtcParam(filters.endDate, "end");
    if (fromUtc) url += `&from=${encodeURIComponent(fromUtc)}`;
    if (toUtc) url += `&to=${encodeURIComponent(toUtc)}`;
    if (filters.status) url += `&status=${filters.status}`;

    const res = await fetch(url, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    const json = await res.json();

    if (json.error) {
      console.error("❌ Failed to fetch tasks:", json.message);
      return [];
    }

    return (json.data?.tasks || []).map((item) => ({
      id: item.id,
      title: item.title || "-",
      priority: item.priority || "-",
      createdAt: formatDateTime(item.created_at),
      deadline: formatDateTime(item.end_at),
      location: item.location_address || "-",
      status: item.status || "-",
    }));
  } catch (err) {
    console.error("❌ Error fetching all tasks:", err);
    return [];
  }
};

  const handleIcon = () => {
    navigate("/my-tasks", { state: { fromDashboard: true } });
}

  const currentPage = Math.min(page, totalPages);

if (isInitialLoad && loading) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "70vh",
      }}
    >
      <CircularProgress size={40} />
    </Box>
  );
}

  return (

    <>
 

    <Box
      sx={{
        backgroundColor: "white",
        borderRadius: 2,
        py: 2,
        mt: 1.5,
        border: "2px solid #091E4224",
      }}
    >
      {/* ✅ Header with Search & Add */}

     
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: isMobile ? "wrap" : "nowrap",
          pb: 2,
          px: 2,
          borderBottom: "2px solid #091E4224",
          gap: 2,
        }}
      >
              <Box sx={{ flex:1, display: "flex", alignItems: "center", gap: 1 }}>
      
          <CustomText
            sx={{
              ...textStyles.h1,
              fontWeight: 600,
              fontSize: "18px",
              color: "#003149",
              textAlign: "left",
            }}
          >
            {t("projectManagement.manageTasks")}
          </CustomText>
          {loading && !isInitialLoad && (
  <CircularProgress size={18} sx={{}} />
)}
        </Box>
        <Box sx={{ flex: 1, display: "flex", justifyContent: "center" }}>
          <SearchInput
            placeholder={t("projectManagement.searchTasks")}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </Box>
        <Box sx={{ flex: 1, display: "flex", justifyContent: "flex-end", gap: 1 }}>

    <IconButton>
                   <img
                      src={mapicon}
                      onClick={handleIcon}
                      alt="map"
                      style={{ width: 33, height: 33 }}
                    />
                  </IconButton>
        </Box>
      </Box>

      {/* ✅ Table */}
      <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
        <Table>
          <TableHead
            sx={{
              borderTop: "2px solid #091E4224",
              borderBottom: "2px solid #091E4224",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            <TableRow>
              <TableCell sx={{ ...HaederStyles }}>{t("projectManagement.id")}</TableCell>
              <TableCell sx={{ ...HaederStyles }}>{t("projectManagement.taskName")}</TableCell>
              <TableCell sx={{ ...HaederStyles }}>{t("projectManagement.priority")}</TableCell>


               <TableCell sx={{ ...HaederStyles }}>{t("projectManagement.createdAt")}

  
  </TableCell>

              <TableCell sx={{ ...HaederStyles }}>{t("projectManagement.deadline")}</TableCell>
                            <TableCell sx={{ ...HaederStyles }}>{t("projectManagement.location")}</TableCell>

              <TableCell sx={{ ...HaederStyles }}>{t("projectManagement.status")}</TableCell>
              <TableCell sx={{ ...HaederStyles }}>{t("reviewStatusLabel")}</TableCell>
              <TableCell sx={{ ...HaederStyles }}>{t("projectManagement.action")}</TableCell>
            </TableRow>
          </TableHead>
      
<TableBody>
  {!loading && (() => {
    if (tasks.length === 0) {
      return (
        <TableRow>
          <TableCell colSpan={9}>
            <Box
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                py: 5,
              }}
            >
              <img
                src={empty}
                alt="No Data"
                style={{ width: 200, marginBottom: 16 }}
              />
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontWeight: 500,
                  fontSize: "16px",
                  color: "#003149",
                }}
              >
                {t("empty.no_user")}
              </CustomText>
            </Box>
          </TableCell>
        </TableRow>
      );
    }

    return tasks.map((row, i) => (
      <TableRow key={i}>
        <TableCell sx={{ ...DataStyles }}>{row.id}</TableCell>
        <TableCell sx={{ ...DataStyles }}>
          <TruncatedCell text={row.title} />
        </TableCell>
   
        <TableCell>
          <Box sx={{ pointerEvents: "none" }}>
            <StatusDropdown currentStatus={row.priority} />
          </Box>
        </TableCell>
        <TableCell sx={{ ...DataStyles }}>
          {formatDateTime(row.created_at)}
        </TableCell>
        <TableCell sx={{ ...DataStyles }}>
          {formatDateTime(row.end_at)}
        </TableCell>
          <TableCell sx={{ ...DataStyles }}>
         <TruncatedCell text={row.location_address}/>
        </TableCell>
        <TableCell>
          
          <Box sx={{ pointerEvents: "none" }}>
            <StatusDropdown currentStatus={row.status} />
          </Box>
        </TableCell>
       <TableCell sx={{ ...DataStyles }}>
  {row.review_status
    ? t(`reviewStatus.${row.review_status.toLowerCase()}`)
    : ""}
</TableCell>
       
        <TableCell>
          <IconButton
            size="small"
            onClick={(e) => handleMenuOpen(e, row)}
          >
            <MoreVertIcon fontSize="small" />
          </IconButton>
        </TableCell>
      </TableRow>
    ));
  })()}
</TableBody>

        </Table>
      </TableContainer>

      {/* ✅ Pagination */}
  <Box sx={{ display: "flex", flexWrap: "wrap", justifyContent: "center", mt: 2 }}>
  <Pagination
    count={totalPages}
    page={currentPage}
    onChange={(_, v) => setPage(v)} // ✅ updates state, triggers fetch
    shape="rounded"
    color="primary"
    size="small"
  />
</Box>
<Menu
  anchorEl={anchorEl}
  open={Boolean(anchorEl)}
  onClose={handleMenuClose}
>
  <MenuItem onClick={handleView} sx={{fontSize:"12px"}}>
       {t("common.view")}
  </MenuItem>
   
  
  {/* Later you can add Edit/Delete here */}
</Menu>



   
    </Box>
    </>
  );
};

export default TasksTable;




